/*
|--------------------------------------------------------------------------
| Custom Javascript code
|--------------------------------------------------------------------------
|
| Now that you configured your website, you can write additional Javascript
| code inside the following function. You might want to add more plugins and
| initialize them in this file.
|
*/

const $ = require('jquery')

const getUrlParameter = sParam => {
  const sPageURL = decodeURIComponent(window.location.search.substring(1))
  const sURLVariables = sPageURL.split('&')
  let sParameterName
  for (let i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=')

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1]
    }
  }
}

const track = (...opts) => {
  if (window.analytics) {
    window.analytics.track(...opts)
  } else {
    // delay for 4 seconds until analytics.js is loaded
    setTimeout(() => {
      window.analytics.track(...opts)
    }, 4000)
  }
}

const normalizeEmail = email => {
  if (email) {
    return email.toLowerCase().trim()
  } else {
    return null
  }
}

const identify = (...opts) => {
  if (window.analytics) {
    window.analytics.identify(...opts)
  } else {
    // delay for 4 seconds until analytics.js is loaded
    setTimeout(() => {
      window.analytics.identify(...opts)
    }, 4000)
  }
}
const alias = (...opts) => {
  if (window.analytics) {
    window.analytics.alias(...opts)
  } else {
    // delay for 4 seconds until analytics.js is loaded
    setTimeout(() => {
      window.analytics.alias(...opts)
    }, 4000)
  }
}

const customerEmail = normalizeEmail(
  window.localStorage.getItem('customer_email')
)

$(() => {
  if (customerEmail) {
    $('#email').val(customerEmail)
    identify(customerEmail, { email: customerEmail })
  }

  $('#getintouch-form').submit(event => {
    $('#getintouch-form').hide()
    $('#getintouch-confirmation').show()
    event.preventDefault()
    const email = normalizeEmail($('#email').val())

    window.localStorage.setItem('customer_email', email)
    alias(email)
    identify(email, { email })

    track('Submitted get in touch', {
      eventCategory: 'Submit'
    })
  })

  /**
   * Analytics
   */
  $('.getintouch').on('click', () => {
    track('Clicked demo', {
      eventCategory: 'Click'
    })
  })

  $('.learnmore').on('click', () => {
    track('Clicked learn more', {
      eventCategory: 'Click'
    })
  })

  $('.getstarted').on('click', () => {
    const plan = window.localStorage.getItem('plan')
    track('Clicked pricing plan', {
      eventCategory: 'Click',
      plan
    })
  })

  $('.open-chat').on('click', () => {
    window.loadBeacon()
    window.Beacon('open')
  })

  const via = getUrlParameter('via')
  if (via) {
    track('Loaded referral link', {
      via
    })
  }
})
